<template>
  <div
    v-if="isImpersonating"
    class="impersonation-banner d-flex align-items-center justify-content-center px-3"
  >
    <font-awesome-icon
      :icon="['fas', 'exclamation-triangle']"
      class="mr-2"
    />

    <span>
      Viewing <strong>{{ accountDetails.name }}</strong>
      <span v-if="accountDetails.type">({{ accountDetails.type }})</span>
      as admin — actions are logged.
    </span>

    <a
      v-if="adminAccountUrl"
      :href="adminAccountUrl"
      target="_blank"
      rel="noopener"
      class="ml-3 text-dark font-weight-bold"
    >
      <font-awesome-icon
        :icon="['fas', 'external-link-alt']"
        class="mr-1"
      />
      Open in Admin UI
    </a>

    <b-button
      variant="light"
      size="sm"
      class="ml-3"
      :disabled="isExiting"
      @click="exitImpersonation"
    >
      <b-spinner
        v-if="isExiting"
        small
        class="mr-1"
      />
      Exit
    </b-button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { showErrorMessage } from '@/notification-utils'

export default {
  name: 'ImpersonationBanner',

  data() {
    return {
      isExiting: false
    }
  },

  computed: {
    ...mapState('auth', ['userDetails']),
    ...mapGetters('auth', ['isImpersonating', 'accountDetails']),

    adminAccountUrl() {
      const baseUrl = process.env.VUE_APP_ADMIN_SIDE_BASE_URL?.replace(/\/$/, '')
      const accountId = this.accountDetails?.id
      const accountType = this.accountDetails?.type?.toLowerCase()

      if (!baseUrl || !accountId || !accountType) {
        return null
      }

      return `${baseUrl}/dashboard/accounts/${accountType}/${accountId}`
    }
  },

  methods: {
    ...mapActions('auth', ['switchCurrentAccount']),

    async exitImpersonation() {
      const ownAccounts = this.userDetails?.accounts
      const targetAccount = Array.isArray(ownAccounts) ? ownAccounts.find(a => a.accountId) : null

      if (!targetAccount) {
        this.$router.push({ name: 'AdminSwitchAccount' })
        return
      }

      try {
        this.isExiting = true

        await this.switchCurrentAccount(targetAccount.accountId)

        window.location.assign('/admin/switch-account')
      } catch {
        showErrorMessage('Unable to exit impersonation, please try again.')
        this.isExiting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.impersonation-banner {
  position: fixed;
  z-index: $zindex-tooltip;
  top: 0;
  left: 0;
  right: 0;
  background: #{$warning}cc;
  color: #000;
  line-height: 2.5;
  overflow: hidden;
  box-shadow: 0 0 5px black;
  opacity: 0.92;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 1;
  }
}
</style>
